import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-edit-payee-complete',
  templateUrl: './edit-payee-complete.component.html',
styleUrls:  ['./edit-payee-complete.component.css']
})
export class EditPayeeCompleteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
